import { useEffect, useState } from 'react'

import { useQuerySelector } from '@src/hooks/useQuerySelector'

/*
  This hook is used to check if the HeadlessUI portal is ready.
  Needed as rendering HeadlessUI dialogs on the server side can cause unexpected behavior.
*/
export function useHeadlessUIReady() {
  const [isReady, setIsReady] = useState(false)
  const headlessUIRootElement = useQuerySelector('#headlessui-portal-root')
  const isHeadlessUILoaded = (headlessUIRootElement?.children?.length ?? 0) > 0

  useEffect(() => {
    if (isHeadlessUILoaded) {
      const timeout = setTimeout(() => {
        setIsReady(true)
      }, 300)
      return () => clearTimeout(timeout)
    }
  }, [isHeadlessUILoaded])

  return isReady
}
